import router from "@/router"
import scrollToTop from "@/composables/scrollToTop"
import { GlobalVariables } from "@/helpers/globalVariables"
import { useUserStore } from "@/stores/user"

// FUNCTION
export default function linkToCoachSelection() {
  const userStore = useUserStore()
  const routeName = userStore.isCoachingHasEngaged
    ? GlobalVariables.urls.coaching.children.home.routeName
    : userStore.isExecutiveCoachingPotential
      ? GlobalVariables.urls.coaching.children.chooseCoach.routeName
      : GlobalVariables.urls.coaching.children.selectCoach.routeName
  router.push({ name: routeName })
  scrollToTop()
}
